/*
 * Zestaw garniturowy (bundle) — patrz snippets/zestaw-garnitur.liquid.
 * Marynarka i spodnie trafiają do koszyka jako osobne pozycje (osobne stany magazynowe),
 * opcjonalnie z gratisem (np. skarpety), oznaczone ukrytą właściwością `_zestaw`.
 */
if (!customElements.get('zestaw-garnitur')) {
  customElements.define(
    'zestaw-garnitur',
    class ZestawGarnitur extends HTMLElement {
      connectedCallback() {
        this.teksty = this.czytajJson('[data-teksty]') || {};
        this.przycisk = this.querySelector('[data-dodaj]');
        this.komunikat = this.querySelector('[data-komunikat]');
        this.suma = this.querySelector('[data-suma]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'pl', {
          style: 'currency',
          currency: this.dataset.currency || 'PLN',
        });

        this.addEventListener('change', () => this.odswiez());
        this.przycisk.addEventListener('click', () => this.dodaj());
        this.odswiez();
        this.zamontujHotspoty();
      }

      czytajJson(selektor, root = this) {
        const el = root.querySelector(selektor);
        if (!el) return null;
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          console.error('[zestaw] Niepoprawny JSON w', selektor, e);
          return null;
        }
      }

      wybrany(rola) {
        return this.querySelector(`input[name="zestaw-${this.dataset.section}-${rola}"]:checked`);
      }

      odswiez() {
        let suma = 0;
        ['marynarka', 'spodnie'].forEach((rola) => {
          const input = this.wybrany(rola);
          const czesc = this.querySelector(`[data-rola="${rola}"]`);
          if (input) {
            suma += Number(input.dataset.cenaCenty);
            czesc.querySelector('[data-cena]').textContent = input.dataset.cena;
          } else {
            const min = Math.min(
              ...[...czesc.querySelectorAll('input:not([disabled])')].map((i) => Number(i.dataset.cenaCenty))
            );
            if (Number.isFinite(min)) suma += min;
          }
        });
        if (suma) this.suma.textContent = this.formatter.format(suma / 100);

        const brakuje = ['marynarka', 'spodnie'].filter((rola) => !this.wybrany(rola));
        this.przycisk.disabled = brakuje.length > 0;
        this.komunikat.textContent = brakuje.length ? this.teksty.wybierz || '' : '';
      }

      async dodaj() {
        const marynarka = this.wybrany('marynarka');
        const spodnie = this.wybrany('spodnie');
        if (!marynarka || !spodnie) return;

        const zestaw = this.dataset.zestaw;
        const items = [
          { id: Number(marynarka.value), quantity: 1, properties: { _zestaw: zestaw } },
          { id: Number(spodnie.value), quantity: 1, properties: { _zestaw: zestaw } },
        ];
        const gratis = this.querySelector(`[name="zestaw-${this.dataset.section}-gratis"]`);
        if (gratis && gratis.value) {
          items.push({ id: Number(gratis.value), quantity: 1, properties: { _zestaw: zestaw, _gratis: 'tak' } });
        }

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.section || s.id);
          body.sections_url = window.location.pathname;
        }

        this.przycisk.classList.add('loading');
        this.przycisk.setAttribute('aria-disabled', 'true');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.komunikat.textContent = '';

        try {
          const res = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.komunikat.textContent = data.description || data.message || this.teksty.blad || '';
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zestaw-garnitur', cartData: data });
          }
          if (cart && document.querySelector('cart-drawer') && data.sections) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
          this.komunikat.textContent = this.teksty.dodano || '';
        } catch (e) {
          console.error('[zestaw]', e);
          this.komunikat.textContent = this.teksty.blad || '';
        } finally {
          this.przycisk.classList.remove('loading');
          this.przycisk.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      /* ---------- Hotspoty na zdjęciu modela ---------- */

      zamontujHotspoty() {
        const szablon = this.querySelector('[data-hotspoty-szablon]');
        const galeria = document.querySelector(`#MainProduct-${this.dataset.section} media-gallery`);
        const slajd = galeria?.querySelector('.product__media-list > .product__media-item');
        if (!szablon || !slajd) return;

        const tresc = szablon.content;
        const punkty = this.czytajJson('[data-hotspoty]', tresc) || [];
        const produkty = this.czytajJson('[data-hotspoty-produkty]', tresc) || {};
        this.tekstyHotspot = this.czytajJson('[data-hotspoty-teksty]') || {};

        slajd.querySelector('.zestaw-hotspoty')?.remove();
        const warstwa = document.createElement('div');
        warstwa.className = 'zestaw-hotspoty';
        slajd.classList.add('zestaw-hotspoty-host');

        punkty.forEach((pkt, i) => {
          const x = Math.min(100, Math.max(0, Number(pkt.x)));
          const y = Math.min(100, Math.max(0, Number(pkt.y)));
          if (!Number.isFinite(x) || !Number.isFinite(y)) return;
          const wbudowany = produkty[pkt.cel];
          const id = `Zestaw-hotspot-${this.dataset.section}-${i}`;

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'zestaw-hotspot';
          btn.style.left = `${x}%`;
          btn.style.top = `${y}%`;
          btn.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-controls', id);
          btn.setAttribute('aria-label', pkt.etykieta || wbudowany?.title || pkt.cel);

          const karta = document.createElement('div');
          karta.className = 'zestaw-hotspot__karta';
          karta.id = id;
          karta.hidden = true;
          if (x > 60) karta.classList.add('zestaw-hotspot__karta--lewo');
          if (y > 60) karta.classList.add('zestaw-hotspot__karta--gora');
          karta.style.left = `${x}%`;
          karta.style.top = `${y}%`;

          btn.addEventListener('click', async (e) => {
            e.stopPropagation();
            const otwarta = btn.getAttribute('aria-expanded') === 'true';
            this.zamknijKarty();
            if (otwarta) return;
            if (!karta.dataset.gotowa) {
              const dane = wbudowany || (await this.pobierzProdukt(pkt.cel));
              if (!dane) return;
              this.wypelnijKarte(karta, dane, wbudowany ? pkt.cel : null);
            }
            karta.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
          });

          warstwa.append(btn, karta);
        });

        slajd.append(warstwa);
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.zestaw-hotspot__karta')) this.zamknijKarty();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.zamknijKarty(true);
        });
      }

      zamknijKarty(fokus = false) {
        document.querySelectorAll('.zestaw-hotspot[aria-expanded="true"]').forEach((b) => {
          b.setAttribute('aria-expanded', 'false');
          document.getElementById(b.getAttribute('aria-controls')).hidden = true;
          if (fokus) b.focus();
        });
      }

      async pobierzProdukt(handle) {
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
          if (!res.ok) return null;
          const p = await res.json();
          return {
            title: p.title,
            url: p.url,
            cena: this.formatter.format(p.price / 100),
            obraz: p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=240` : '',
          };
        } catch (e) {
          return null;
        }
      }

      wypelnijKarte(karta, dane, rola) {
        const t = this.tekstyHotspot;
        karta.innerHTML = `
          ${dane.obraz ? `<img src="${dane.obraz}" alt="" width="80" height="100" loading="lazy">` : ''}
          <div>
            <p class="zestaw-hotspot__tytul"></p>
            <p class="zestaw-hotspot__cena"></p>
            <div class="zestaw-hotspot__akcje">
              ${rola ? `<button type="button" class="link" data-przewin>${t.wybierz || ''}</button>` : ''}
              <a class="link" href="${dane.url}">${t.zobacz || ''}</a>
            </div>
          </div>`;
        karta.querySelector('.zestaw-hotspot__tytul').textContent = dane.title;
        karta.querySelector('.zestaw-hotspot__cena').textContent = dane.cena;
        karta.querySelector('[data-przewin]')?.addEventListener('click', () => {
          const cel = this.querySelector(`[data-rola="${rola}"]`);
          this.zamknijKarty();
          cel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          cel.classList.add('is-podswietlony');
          cel.focus({ preventScroll: true });
          setTimeout(() => cel.classList.remove('is-podswietlony'), 1600);
        });
        karta.dataset.gotowa = 'true';
      }
    }
  );
}
